import angular from 'angular';
import _ from 'lodash';

angular.module('settings', ['application', 'ngAnimate']);

angular.module('settings').config(["$stateProvider", "$translatePartialLoaderProvider", function($stateProvider, $translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('settings');

    $stateProvider.state('app.settings', {
        url: '/settings',
        redirectTo: (trans) => trans.injector().get('checkManager').isModuleAngular('settings.general') ? 'app.new.settings.hub' : 'app.settings.general'
    });

    $stateProvider.state('app.settings.general', {
        url: '/general',
        views: {
            "appContent@app": {
                template: require('./partial/general-settings/general-settings.html'),
                controller: 'GeneralSettingsCtrl'
            }
        },
        resolve: {
            departments: ["entityManager", (entityManager) => entityManager.departments.fetchCollectionOffline() ],
            nonFiscalDocuments: ["entityManager", (entityManager) => entityManager.nonfiscalDocuments.fetchCollectionOffline()],
            paymentMethods: ["entityManager", (entityManager) => entityManager.paymentMethods.fetchCollectionOffline() ],
            preferencesData: ["checkManager", (checkManager) => checkManager.getShopPreferences() ],
            printers: ["entityManager", (entityManager) => entityManager.printers.fetchCollectionOffline() ]
        }
    });

    $stateProvider.state('app.settings.kiosk', {
        url:'/old_kiosk',
        views: {
            "appContent@app": {
                template: require('./partial/kiosk-settings/kiosk-settings.html'),
                controller: 'KioskSettingsCtrl'
            }
        },
        resolve: {
            preferencesData: ["checkManager", function(checkManager) {
                return checkManager.getShopPreferences('kiosk.');
            }]
        }
    });

    /* Add New States Above */
}]);
